import CtaButton from 'components/Widget/Button/CtaButton';
import { shallowEqual, useSelector } from 'react-redux';
import { selectIsGuest } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';
import * as Island from '../styles';

const GuestCta = () => {
	const { isGuest } = useSelector(
		(r: RootReducer) => ({
			isGuest: selectIsGuest(r.db),
		}),
		shallowEqual
	);

	if (!isGuest) return null;

	return (
		<Island.BottomRight>
			<CtaButton minimal={false} />
		</Island.BottomRight>
	);
};

export default GuestCta;
